<template>
  <svg
    version="1.1"
    :id="iconName"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 22 20"
    fill="none"
    style="enable-background:new 0 0 22 20;"
    :class="iconName"
    xml:space="preserve"
    :width="width"
    :height="height"
  >
    <title :id="iconName" lang="en">{{ iconName }} icon</title>
    <g id="icon_news">
      <path
        id="Rectangle 16"
        d="M9 1H21V16C21 17.6569 19.6569 19 18 19H3.5"
        stroke-linejoin="round"
      />
      <path
        id="Ellipse 42"
        d="M6 16.5C6 17.8807 4.88071 19 3.5 19C2.11929 19 1 17.8807 1 16.5"
      />
      <path
        id="Rectangle 18"
        d="M6 16.5V1H10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        id="Rectangle 17"
        d="M4 3.5C4.27614 3.5 4.5 3.72386 4.5 4C4.5 4.27614 4.27614 4.5 4 4.5V3.5ZM1 4H0.5C0.5 3.72386 0.723858 3.5 1 3.5V4ZM4 4.5H1V3.5H4V4.5ZM1.5 4V16.5H0.5V4H1.5Z"
      />
      <path
        id="Rectangle 19"
        d="M3 6L3 14"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path id="Vector 12" d="M9 13H15" stroke-linecap="round" />
      <rect
        id="Rectangle 20"
        x="9.08398"
        y="4"
        width="6"
        height="6"
        stroke-linejoin="round"
      />
      <path
        id="Rectangle 21"
        d="M9.58398 10L12.1592 7.68166C12.5751 7.30726 13.2173 7.34698 13.5838 7.76978L15.084 9.5"
        stroke-linejoin="round"
      />
      <path
        id="Rectangle 22"
        d="M9.08374 7L9.24296 6.80875C9.60912 6.36892 10.269 6.32553 10.6896 6.71363L12.0837 8"
        stroke-linejoin="round"
      />
      <path id="Vector 13" d="M9 15H15" stroke-linecap="round" />
    </g>
  </svg>
</template>
<style scoped>
.icon-news {
  stroke: currentColor;
  height: 24px;
  width: 24px;
  border-radius: initial;
  display: block;
}
</style>
<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "icon-news"
    },
    width: {
      type: [Number, String],
      default: 12
    },
    height: {
      type: [Number, String],
      default: 12
    },
    iconColor: {
      type: String,
      default: "currentColor"
    }
  }
};
</script>